export default function () {
  const links = document.querySelectorAll(".disable-on-click")

  links.forEach((link) => {
    link.addEventListener("click", function (event) {
      if (link.dataset.disabled === "true") {
        event.preventDefault()
        return
      }

      link.dataset.disabled = "true"
      const confirmMessage = link.dataset.message || "Are you sure?"
      const userConfirmed = window.confirm(confirmMessage)

      if (userConfirmed) {
        link.classList.add("hover:no-underline", "hover:text-gray-500", "text-gray-500")
      } else {
        link.dataset.disabled = "false"
        event.preventDefault()
      }
    })
  })
}
